module.exports = __webpack_public_path__ + "img/doorLogo3.b9ae2552.png";